import ReviewsSnippet from './ReviewsSnippet'

export default ReviewsSnippet
